export function registerAppPolyFills(): void {
  elementMatchesPolyfill();
}

function elementMatchesPolyfill(): void {
  if (!Element.prototype.matches) {
    Element.prototype.matches = (Element.prototype as any).msMatchesSelector || Element.prototype.webkitMatchesSelector;
  }
}
